import groq from 'groq';

export const CAPTIONS_VIDEO = groq`
  title,
  "cloudinaryId": video.public_id,
  "vtt": vtt,
  "itemKey": ^._key
`;
